var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var DistrictSearch = require("components/org/roster/DistrictSearch");
var Glyphicon = require("components/utility/icons/Glyphicon");
import ReactSelect from "react-select";

import { Link } from "react-router-dom";


class CleverLinkDistrictAdmins extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		
		this.state = { districtAdmins:null, selectedDistrictAdmin: {}}
	}

	onSelectDistrictAdmin(clever_admin, admin) {
		var selectedDistrictAdmin = this.state.selectedDistrictAdmin
		selectedDistrictAdmin[clever_admin.clever_id] = admin
		this.setState({ selectedDistrictAdmin })
	}

	renderDistrictAdminOptions(admin) {

		var options = _.map(this.state.districtAdmins, (admin) => {
			return {value: admin, label: [admin.first_name, admin.last_name].join(" ")}
		})
		return <ReactSelect name="school-org" value={ this.state.selectedDistrictAdmin[admin.clever_id] }
						options={ options } onChange={ this.onSelectDistrictAdmin.bind(this, admin) } />
	}

	renderDistrictAdmins() {
		var adminRows = _.map(this.props.admins, (admin, a) => {
			if (admin.user_id) {
				var action = (
					"Linked!"
				)
			} else if (admin.clever_id in this.state.selectedDistrictAdmin) {
				var action = (
					<button className="btn btn-primary" onClick={this.linkAdmin.bind(this, admin)}>
						Link Admin
					</button>
				)
			} else {
				var action = (
					<button className="btn btn-default" onClick={this.createAdmin.bind(this, admin)}>
						Create Admin
					</button>
				)
			}

			return (
				<tr key={a}>
					<td>
						{admin.first_name} {admin.last_name}
					</td>
					<td>
						{ admin.title }
					</td>
					<td>
						{ this.renderDistrictAdminOptions(admin) }
					</td>
					<td>
						{ action }
					</td>
				</tr>
			)
		})
		return (
			<table className="table">
				<thead>
					<tr>
						<th>
							Name
						</th>
						<th>
							Title
						</th>
						<th>
							District Admins
						</th>
						<th>
							Link Action
						</th>
					</tr>

				</thead>
				<tbody>
					{ adminRows }
				</tbody>
			</table>
		)
	}

	render() {

		if (this.state.districtAdmins) {
			var view = this.renderDistrictAdmins()
		} else {
			var view = <Spinner placeholder={ true } scale={ 0.5 } />
		}
		

		return (
			<div className="CleverLinkDistrictAdmins">
				{ view }
			</div>
		);
	}

	componentDidMount() {
		this.fetchDistrictOrgAdmin()
	}

	fetchDistrictOrgAdmin() {
		CurrentUser.api().getDistrictOrg(this.props.districtOrg.id, {embed: "district_org.admins"} , $wr.apiHandler((response) => {
			this.setState({districtAdmins: response.district_org.admins})
		}));
	}

	linkAdmin(cleverAdmin) {
		var admin = this.state.selectedDistrictAdmin[cleverAdmin.clever_id].value

		CurrentUser.api().patchAdmin(admin.id, {clever_user_id: cleverAdmin.clever_id} , $wr.apiHandler((response) => {
			this.props.onDistrictAdminUpdate(cleverAdmin, admin)
			this.forceUpdate()
		}));
	}

	createAdmin(cleverAdmin) {

		CurrentUser.api().postAdmins({admin: {clever_user_id: cleverAdmin.clever_id}, signup_type: "clever"} , $wr.apiHandler((response) => {
			this.props.onDistrictAdminUpdate(cleverAdmin, response.admin)
			this.forceUpdate()
		}));
	}
};

CleverLinkDistrictAdmins.propTypes = PageStrictPropTypes({
});

module.exports = CleverLinkDistrictAdmins;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/CleverLinkDistrictAdmins.js